import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Joce } from '../models/Joce';

@Component({
  selector: 'app-joce',
  templateUrl: './joce.component.html'
})
export class JoceComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Joce';
  @Input() parentForm: FormGroup;
  @Input() joce: Joce;

  constructor() {
  }

  public ngOnInit() {
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
